import { fromJS } from 'immutable';

export default {
    setManagements: (state, managements) => {
        return state.setIn(['list'], fromJS(managements)).set('initialized', true);
    },
    setManagement: (state, managementId, management) => {
        return state.setIn(['list', managementId.toString()], fromJS(management));
    },
    updateManagement: (state, managementId, management) => {
        return state.mergeIn(['list', managementId.toString()], fromJS(management));
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Managements/core.js